import config from './../../../static/config/index.js'

export default {
  state: {
    _devices: [],
    devices: {},//分机 {exten:12,status:offline,out:0,deptid:1,deptname:c,cameraflag:0,employeename:12,employeeid:1,position:xxx,order:1}
    extractDevices: [],//系统外号码分机 振铃存储，挂机去除
    deviceStatus: [],//分机状态
    roleExten: {},
    leftStatus: 'OffLine',
    rightStatus: 'OffLine',
    groups: [],//组织 {deptid:1,deptname:A,inline:12,offline:10,all:22,order:1}
    conferences: [],//正在开的会议分机 {IsCanSpeak: true,cameraflag: "0",confname: "1",
    // confno: "1",deptid: "1",deptname: "上海",employeeid: "4",employeename: "865",
    // exten: "865",mac: "",model_name: "",network: "10.1.21.145:63574",order: "-1",
    // out: "0",position: "",status: "Idle",supportOffline: "0",type_id: "",type_name: "",volume: ""}
    queueList: [],//通话队列{exten: '',vip: ''}
    callList: [],//通话列表
    callListData: [],//当前通话列表
    noanswers: [],
    nowconferences: [],//当前会议室成员
    confList: [],//会议室列表
    confNums: [],//固定会议室号码
    invateOutLines: [],
    callConfList: [],//会议室消息列表
    tempConfList: [],//临时会议室列表
    broadFresh: false,//是否刷新广播表格
    broadStart: false,
    noBroad: true,
    broadVolume: false,

    linkGroups: [],//联系人组
    selfLinkGroups: [],

    sysGeneral: [],//系统配置
    inline: false,
    //缓存的视频使用端口
    destroy: true,
    //转接号码
    transferPhone: '',
    playingBroad: [],
    noAccessTalkingExten: [],
    //alarm device
    alarmDevs: [],
    myWebRtc: undefined,
    ports: [{port: config.port[0], number: 0},
      {port: config.port[1], number: 0},
      {port: config.port[2], number: 0},
      {port: config.port[3], number: 0},
      {port: config.port[4], number: 0},
      {port: config.port[5], number: 0}],
    httpsPorts: [{port: config.httpsPorts[0], number: 0},
      {port: config.httpsPorts[1], number: 0},
      {port: config.httpsPorts[2], number: 0},
      {port: config.httpsPorts[3], number: 0},
      {port: config.httpsPorts[4], number: 0}],

    sizesConfig: [33.333333, 33.333333, 33.333333],//面板比例
    openPanelConfig: ['call-info', 'call-queue', 'no-answer'],//指定展开面板
    openPanelConfigNoChange: [],//指定展开面板,仅用来与后台交付，前端不要改动
    noDraggingConfig: '',//禁止拖动出现的位置，利用css实现
    cache_part_id: '-1',//缓存临时part_id
    queueCallInfo: null,
    isLeftRefresh: '0',
    isChangeAlarm: '0',//刷新主控台左側树的报警灯
    windowClear: false,//关闭子窗口
    isAlarmDept: [],
    isShowChild: null,//多级管理是否显示下级数据
    timerNumber: 0,//多级管理刷新页面时间。
    videoCount: 0,
    monitorVideoList: [],//视频监视存储的播放流
    monitorUUID: '',//视频监视自主断流的uuid
    hasMonitor: false,//是否有监视的授权。
    gradeSystemInfo: [],//级联系统信息
    gradeExten: new Map(),
    systemTime: null,//服务器时间
    cascadeFirst: false,//是否是登录后第一次进入级联管理。
    isEPX: null,//系统是否是epx
    languageList: [],//系统内置语言
    extCount: [],//系统分机数量
    isOtherCall: '0',//用来判断是否是主动点击呼叫,0是没点，，1是点了。
    showVideoBtn:'1',
  },
  mutations: {
    setGradeExten(state, gradeExten) {
      state.gradeExten = gradeExten
    },
    setWindowClear(state, windowClear) {
      state.windowClear = windowClear
    },
    setQueueCallInfo(state, queueCallInfo) {
      state.queueCallInfo = queueCallInfo
    },
    setNoAnswers(state, noanswers) {
      state.noanswers = noanswers
    },
    setRoleExten(state,roleExten){
      state.roleExten = roleExten
    },
    setCache_part_id(state, cache_part_id) {
      state.cache_part_id = cache_part_id
    },
    setNoAccessTalkingExten(state,noAccessTalkingExten) {
      state.noAccessTalkingExten = noAccessTalkingExten
    },
    setNoDraggingConfig(state, noDraggingConfig) {
      state.noDraggingConfig = noDraggingConfig
    },
    setTempConfList(state, tempConfList) {
      state.tempConfList = tempConfList
    },
    setInvateOutLines(state, invateOutLines) {
      state.invateOutLines = invateOutLines
    },
    setPlayingBroad(state,playingBroad){
      state.playingBroad = playingBroad
    },
    setOpenPanelConfig(state, openPanelConfig) {
      state.openPanelConfig = openPanelConfig
    },
    setShowVideoBtn(state, showVideoBtn){
      state.showVideoBtn = showVideoBtn
    },
    setOpenPanelConfigNoChange(state, openPanelConfigNoChange) {
      state.openPanelConfigNoChange = openPanelConfigNoChange
    },
    setSizesConfig(state, sizesConfig) {
      state.sizesConfig = sizesConfig
    },
    setCallListData(state, callListData) {
      state.callListData = callListData
    },
    setTransferPhone(state, transferPhone) {
      state.transferPhone = transferPhone
    },
    setBroadStart(state, broadStart) {
      state.broadStart = broadStart
    },
    setLeftStatus(state, leftStatus) {
      state.leftStatus = leftStatus
    },
    setRightStatus(state, rightStatus) {
      state.rightStatus = rightStatus
    },
    setMyWebRtc(state, myWebRtc) {
      state.myWebRtc=myWebRtc
    },
    setNoBroad(state, noBroad) {
      state.noBroad = noBroad
    },
    setExtractDevices(state, extractDevices) {
      state.extractDevices = extractDevices
    },
    setPorts(state, ports) {
      state.ports = ports
    },
    setHttpsPorts(state, httpsPorts) {
      state.httpsPorts = httpsPorts
    },
    setAlarmDevs(state, alarmDevs) {
      this.alarmDevs = alarmDevs
    },
    setUserInline(state, inline) {
      state.inline = inline
    },
    setDestroy(state, destroy) {
      state.destroy = destroy
    },
    setDevices(state, extens) {
      extens = !extens ? {} : extens;
      state.devices = extens
    },
    setDeviceStatus(state, deviceStatus) {
      state.deviceStatus = deviceStatus
    },
    setNoStatusDevices(state, extens) {
      state._devices = extens
    },
    setGroups(state, groups) {
      state.groups = groups
    },
    setConferences(state, conferences) {
      state.conferences = conferences
    },
    setNowConferences(state, conferences) {
      state.nowconferences = conferences
    },
    addIsAlarmDept(state, isAlarmDept) {
      if(isAlarmDept){
        let index = state.isAlarmDept.findIndex(item=> item == isAlarmDept);
        if (index < 0) {
          state.isAlarmDept.push(isAlarmDept)
        }
      }
    },
    reduceIsAlarmDept(state, isAlarmDept) {
      let index = state.isAlarmDept.findIndex(item=> item == isAlarmDept);
      if(index > -1){
        state.isAlarmDept.splice(index,1);
      }
    },
    copyIsAlarmDept(state, alarmDeptList) {
      if (alarmDeptList) {
        state.isAlarmDept = JSON.parse(JSON.stringify(alarmDeptList));
      }
    },
    addConferences(state, conference) {
      state.conferences.push(conference)
    },
    setConfList(state, conflist) {
      let partConf = []
      if (conflist.length > 0) {
        for (let i = 0; i < conflist.length; i++) {
          let conf = conflist[i]
          if (conf.confrencename && conf.confrencename.indexOf('-@')>-1) {
            partConf.push(conf)
          }
        }
      }
      state.tempConfList = partConf
      state.confList = (conflist);
      if (conflist.length > 0) {
        let nums = []
        for (let i = 0; i < conflist.length; i++) {
          nums.push(conflist[i].conf_num)
        }
        state.confNums = nums
      }
    },
    updateConfList(state, conflist) {
      state.confList = (conflist);
    },
    setQueueList(state, queue) {
      state.queueList = queue
    },
    addQueueList(state, queue) {
      state.queueList.push(queue)
    },
    setCallList(state, call) {
      state.callList = call
    },
    addCallList(state, call) {
      state.callList.push(call)
    },
    setBroadFresh(state, refresh) {
      state.broadFresh = refresh
    },
    addCallConfList(state, call) {
      state.callConfList.push(call)
    },
    setBroadVolume(state, volume) {
      state.broadVolumeDevice = volume
    },
    setLinkGroups(state, linkGroups) {
      state.linkGroups = linkGroups
    },
    setSelfLinkGroups(state, selfLinkGroups) {
      state.selfLinkGroups = selfLinkGroups
    },
    setSysGeneral(state, sysGeneral) {
      state.sysGeneral = sysGeneral
    },
    setControlLeft(state, isLeftRefresh) {
      state.isLeftRefresh = isLeftRefresh
    },
    setIsShowChild(state, isShowChild) {
      state.isShowChild = isShowChild
    },
    setTimerNumber(state, timerNumber) {
      state.timerNumber = timerNumber
    },
    setVideoCount(state, videoCount) {
      state.videoCount = videoCount
    },
    setMonitorVideoList(state, monitorVideoList) {
      state.monitorVideoList = monitorVideoList
    },
    setMonitorUUID(state, monitorUUID) {
      state.monitorUUID = monitorUUID
    },
    setHasMonitor(state, hasMonitor) {
      state.hasMonitor = hasMonitor
    },
    setGradeSystemInfo(state, gradeSystemInfo) {
      state.gradeSystemInfo = gradeSystemInfo
    },
    setSystemTime(state, systemTime) {
      state.systemTime = systemTime
    },
    setCascadeFirst(state, cascadeFirst) {
      state.cascadeFirst = cascadeFirst
    },
    setIsEPX(state, isEPX) {
      state.isEPX = isEPX;
    },
    setLanguageList(state, languageList) {
      state.languageList = languageList;
    },
    setExtCount(state, extCount) {
      state.extCount = extCount;
    },
    setIsOtherCall(state, isOtherCall) {
      state.isOtherCall = isOtherCall;
    },

  },
  actions: {
    cacheExtens({state, commit}, extens) {
      commit('setDevices', extens)
    },
    cacheConferences({state, commit}, {conference}) {
      commit('setConferences', conference)
    },
  }

};



// WEBPACK FOOTER //
// ./src/store/module/cacheData.js